'use client'
import { useState, useEffect } from 'react'
import ButtonAction from './ButtonAction'
import SubTitle from 'components/privat/SubTitle'
import Separator from 'components/privat/Separator'
import Payment from 'components/privat/Payment'
import HTMLReactParser from 'html-react-parser'

const Form = ({
  form,
  formData,
  setFormData,
  setSendTheForm,
  singleCol = false,
  loading,
  FreeElement = () => {},
  CaptainElement = () => {},
  SubcaptainElement = () => {},
  dynamicData,
  handleBlur,
  errors = {},
  setErrors,
  topSpace = true,
  sendOnlyChanges = false
}) => {
  const [paymentType, setPaymentType] = useState('')

  const handleChange = (event) => {
    if (event?.target) {
      const { name, value, checked } = event.target
      const updateData = { ...formData }
      updateData[name] = checked || value
      setFormData(updateData)
      if (name in errors) {
        setErrors((errors) => {
          delete errors[name]
          return errors
        })
      }
    }
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const fileInfo = {
        name: file.name,
        type: file.type,
        size: file.size,
        base64: reader.result.split('base64,').pop(),
        original: URL.createObjectURL(event.target.files[0])
      }
      if (fileInfo.size > 2000000) {
        console.log('Archivo muy grande')
      } else {
        const { name } = event.target
        const updateData = { ...formData }
        updateData[name] = fileInfo
        setFormData(updateData)
      }
    }
  }

  useEffect(() => {
    if (paymentType) {
      const updateData = { ...formData }
      updateData.paymentType = paymentType
      setFormData(updateData)
    }
  }, [paymentType])

  return (
    <form
      className="lg:grid lg:grid-cols-1 lg:gap-x-12 xl:gap-x-32"
      onSubmit={(event) => {
        event.preventDefault()
        // TODO it doesn't need all the keys, just verify that there is at least 1 change
        // Update - I don't understand why should send all the data?
        if (!Object.keys(formData).length && !sendOnlyChanges) {
          const fullData = {}
          Array(...event.target).forEach(({ name, value }) => {
            fullData[name] = value
          })
          setFormData(fullData)
        }
        setSendTheForm((idx) => idx + 1)
        // resetForm()
      }}
    >
      {form.length
        ? form.map((form, idx) => (
            <div key={idx} className={`${form?.className}`}>
              {form?.section ? (
                <div
                  className={`mb-4 lg:mb-2 border-b border-gray-200 pb-2 ${
                    topSpace && 'mt-10 lg:mt-16'
                  }`}
                >
                  <h2 className="text-[14px] lg:text-lg font-alliance-medium text-blue">
                    {dynamicData?.[form?.section]
                      ? dynamicData?.[form?.section]
                      : form?.section}
                  </h2>
                </div>
              ) : null}

              {form?.description ? (
                <p className="text-blue font-alliance-light text-[14px] lg:text-[22px] mt-4 lg:mt-6">
                  {HTMLReactParser(form?.description)}
                </p>
              ) : null}

              <div className="flex">
                <div
                  className={`mt-2 lg:mt-5 w-full lg:mr-2 grid ${
                    singleCol ? 'lg:grid-cols-1' : 'lg:grid-cols-2'
                  } gap-4`}
                >
                  {form?.fields?.map((field, idx) => {
                    const logic = field.showIfLogic || 'AND'
                    let isHidden =
                      field.showIf?.length &&
                      (logic === 'OR'
                        ? !field.showIf.some((item) =>
                            item.negation
                              ? formData[item.name] !== item.value &&
                                formData?.[item.name] &&
                                formData?.[item.name] !== '0'
                              : formData[item.name] === item.value
                          )
                        : field.showIf.some((item) =>
                            item.negation
                              ? formData[item.name] === item.value ||
                                !formData?.[item.name] ||
                                formData?.[item.name] === '0'
                              : formData[item.name] !== item.value
                          ))
                    if (field.showIfDynamicData && !field.showIf?.length) {
                      isHidden = !dynamicData[field.showIfDynamicData]
                    }
                    return (
                      <div
                        key={idx}
                        className={`mt-2 lg:mt-5 ${
                          isHidden ? 'hidden' : 'block'
                        } ${field?.className || ''}`}
                      >
                        {field?.name && (
                          <label
                            htmlFor={field.id}
                            className="block text-[14px] lg:text-[22px] font-alliance-light text-blue"
                          >
                            {`${field?.name} ${
                              field.required ? field.required && ' *' : ''
                            }`}
                          </label>
                        )}

                        <div className="mt-2">
                          {field?.element == 'input' ? (
                            <>
                              <div
                                className={`flex bg-sec-grey-4 rounded-sm border-sec-grey-4 shadow-sm focus:border-blue focus:ring-blue`}
                              >
                                {field?.type === 'file' ? (
                                  <>
                                    <input
                                      type="file"
                                      id={field.id}
                                      name={field.id}
                                      className="bg-sec-grey-4 block rounded-sm border-none w-full text-blue text-[14px] lg:text-[20px] font-alliance-light h-12 pl-2 py-[8px]"
                                      onChange={handleFileChange}
                                      required={
                                        isHidden ? false : field.required
                                      }
                                      accept={field.fileFormats}
                                    />
                                    <div className="flex justify-center">
                                      <img
                                        src="/assets/icons/clip.svg"
                                        alt="icon"
                                        className="bg-sec-grey-4 ml-5 py-[8px] mr-5 w-6"
                                      />
                                    </div>
                                  </>
                                ) : field?.type === 'password' ? (
                                  <input
                                    type="password"
                                    id={field.id}
                                    name={field.id}
                                    className={`bg-sec-grey-4 block rounded-sm border-none w-full text-[14px] lg:text-[20px] font-alliance-light h-12 ${
                                      field?.readOnly
                                        ? 'text-sec-grey-20'
                                        : 'text-blue'
                                    }`}
                                    onChange={handleChange}
                                    required={isHidden ? false : field.required}
                                    defaultValue={field?.defaultValue}
                                    readOnly={field?.readOnly}
                                    onBlur={handleBlur}
                                    autoComplete={field?.autoComplete}
                                    disabled={field?.readOnly}
                                  />
                                ) : field?.type === 'time' ? (
                                  <input
                                    type="time"
                                    id={field.id}
                                    name={field.id}
                                    className={`bg-sec-grey-4 block rounded-sm border-none w-full text-[14px] lg:text-[20px] font-alliance-light h-12 ${
                                      field?.readOnly
                                        ? 'text-sec-grey-20'
                                        : 'text-blue'
                                    }`}
                                    onChange={handleChange}
                                    required={isHidden ? false : field.required}
                                    defaultValue={field?.defaultValue}
                                    readOnly={field?.readOnly}
                                    onBlur={handleBlur}
                                    autoComplete={field?.autoComplete}
                                    disabled={field?.readOnly}
                                    min={field?.min}
                                    max={field?.max}
                                    step={field?.step}
                                  />
                                ) : (
                                  <input
                                    type={field?.type ?? 'text'}
                                    id={field.id}
                                    name={field.id}
                                    className={`bg-sec-grey-4 block rounded-sm border-none w-full text-[14px] lg:text-[20px] font-alliance-light h-12 ${
                                      field?.readOnly
                                        ? 'text-sec-grey-20'
                                        : 'text-blue'
                                    }`}
                                    onChange={handleChange}
                                    required={isHidden ? false : field.required}
                                    defaultValue={field?.defaultValue}
                                    readOnly={field?.readOnly}
                                    onBlur={handleBlur}
                                    disabled={field?.readOnly}
                                    value={field?.value}
                                  />
                                )}
                              </div>
                              {errors?.[field.id] && (
                                <p className="text-sec-red font-alliance-light text-[14px] mt-2">
                                  {errors?.[field.id]}
                                </p>
                              )}
                            </>
                          ) : null}

                          {field?.element == 'select' ? (
                            <select
                              id={field.id}
                              name={field.id}
                              className={`bg-sec-grey-4 block w-full pt-2 pb-3 rounded-sm text-[16px] lg:text-[20px] font-alliance-light border-sec-grey-4 shadow-sm focus:border-blue focus:ring-blue h-12 ${
                                field?.readOnly
                                  ? 'text-sec-grey-20'
                                  : 'text-blue'
                              }`}
                              onChange={handleChange}
                              required={isHidden ? false : field.required}
                              disabled={field?.readOnly}
                              defaultValue={field?.defaultValue}
                              value={field?.value}
                              style={
                                field?.readOnly
                                  ? { backgroundImage: 'url()' }
                                  : {}
                              }
                            >
                              {field?.createEmptyOption && (
                                <option key="0" value=""></option>
                              )}
                              {(
                                dynamicData?.[field.dynamicData] ||
                                dynamicData?.[field.showIfDynamicData] ||
                                field?.options
                              )?.map((option, idxTwo) => (
                                <option key={idxTwo} value={option?.value}>
                                  {option?.text}
                                </option>
                              ))}
                            </select>
                          ) : null}

                          {field?.element == 'Button' ? (
                            <ButtonAction
                              id={field.id}
                              type={field?.type}
                              text={field?.text}
                              color={field?.color}
                              textColor={field?.textColor}
                              className={field?.className}
                              loading={loading}
                              disabled={
                                !Object.keys(formData).length || loading
                              }
                            />
                          ) : null}

                          {field?.element == 'radio' ? (
                            <fieldset className="lg:col-span-2 lg:mb-6">
                              <div className="flex items-center space-y-0 space-x-10">
                                {field?.options?.map((option) => (
                                  <div
                                    key={option?.id}
                                    className="flex items-center"
                                  >
                                    <input
                                      id={option?.id}
                                      name={field?.id}
                                      type="radio"
                                      value={option?.value}
                                      className="h-4 w-4 border-blue text-blue focus:ring-blue"
                                      defaultChecked={option?.selected}
                                      onChange={handleChange}
                                      required={
                                        isHidden ? false : field.required
                                      }
                                    />
                                    <label
                                      htmlFor={option?.id}
                                      className="ml-3 block font-alliance-light text-[12px] lg:text-[22px] text-blue"
                                    >
                                      {option?.text}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </fieldset>
                          ) : null}

                          {field?.element == 'checkbox' ? (
                            <fieldset className="w-full">
                              <div className="items-center space-y-0 space-x-10">
                                <SubTitle>
                                  <div className="flex items-center">
                                    <input
                                      id={field?.id}
                                      name={field?.id}
                                      type="checkbox"
                                      className="h-7 w-7 mr-3 border-blue text-blue focus:ring-blue"
                                      required={
                                        isHidden ? false : field.required
                                      }
                                      onChange={handleChange}
                                      defaultChecked={field?.defaultChecked}
                                    />
                                    <span>{HTMLReactParser(field?.text)}</span>
                                  </div>
                                </SubTitle>
                                <p className="text-blue font-alliance-light font-[12px]">
                                  {field?.description}
                                </p>
                              </div>
                            </fieldset>
                          ) : null}

                          {field?.element == 'social' ? (
                            <div className="grid grid-cols-1 gap-4">
                              {field?.items?.map((item, idxField) => (
                                <div className="flex" key={idxField}>
                                  <img
                                    src={item?.icon}
                                    alt="icon"
                                    className="mr-4 w-6 lg:w-10"
                                  />
                                  <input
                                    id={item.id}
                                    type="text"
                                    name={item.id}
                                    className="bg-sec-grey-4 block w-full text-blue rounded-sm text-[16px] lg:text-[26px] font-alliance-light border-sec-grey-4 shadow-sm focus:border-blue focus:ring-blue"
                                  />
                                </div>
                              ))}
                            </div>
                          ) : null}

                          {field?.element == 'payment' ? (
                            <div className="grid grid-cols-1 gap-4">
                              <Separator />
                              <SubTitle>Forma de pagament:</SubTitle>
                              <Payment
                                setPaymentType={setPaymentType}
                                walletHidden={field?.walletHidden}
                              />
                              <p className="text-blue font-alliance-light font-[12px] mt-8">
                                {field?.description}
                              </p>
                            </div>
                          ) : null}
                          {field?.element == 'free' && <FreeElement />}
                          {field?.element == 'captain' && <CaptainElement />}
                          {field?.element == 'subcaptain' && (
                            <SubcaptainElement />
                          )}

                          {field?.element === 'textarea' && (
                            <textarea
                              id={field?.id}
                              name={field?.id}
                              className="flex w-full bg-sec-grey-4 rounded-sm border-sec-grey-4 shadow-sm focus:border-blue focus:ring-blue"
                              rows="4"
                              onChange={handleChange}
                            />
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          ))
        : null}
    </form>
  )
}

export default Form
